import { useTranslation } from "react-i18next";
import { ChangerBtn } from "./languageChanger.styles";

const LanguageChanger = (
  props: React.HtmlHTMLAttributes<HTMLButtonElement>,
) => {
  const { i18n } = useTranslation();

  const changeLanguage: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    const lang = e.currentTarget.textContent;
    console.log(lang);

    if (lang === "AR") {
      i18n.changeLanguage("ar");
    } else {
      i18n.changeLanguage("en");
    }
  };
  return (
    <ChangerBtn
      {...props}
      onClick={changeLanguage}
      className="!text-image"
      type="button"
    >
      {i18n.language === "ar" ? "EN" : "AR"}
    </ChangerBtn>
  );
};
export default LanguageChanger;
